import { Footer as WFPFooter, Link } from '@wfp/react';
import React from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';

import { sendGAEvent } from 'src/utils';

type GAEventParams = Record<string, any>;

interface FooterLink {
  id: number;
  label: string;
  url: string;
  open_strategy: 'new_tab' | 'current_tab';
  ga_event_name: string | null;
  order: number;
  ga_event_params: GAEventParams;
}

const Footer: React.FC = () => {
  const appConfig = useSelector<RootStateOrAny, any | undefined>(
    state => state.viewData?.GET_APP_CONFIGURATION?.data,
  );

  const footerLinks: FooterLink[] = appConfig?.footer_links || [];

  return (
    <WFPFooter className="custom-footer">
      <div className="wfp--footer-info footer-link-container">
        {footerLinks
          .sort((a, b) => a.order - b.order)
          .map((link: FooterLink) => (
            <div className="wfp--footer-info__item" key={link.id}>
              <Link
                linkSolid
                href={link.url}
                target={link.open_strategy === 'new_tab' ? '_blank' : '_self'}
                rel={
                  link.open_strategy === 'new_tab'
                    ? 'noopener noreferrer'
                    : undefined
                }
                onClick={() => {
                  if (link.ga_event_name) {
                    sendGAEvent(link.ga_event_name, link.ga_event_params);
                  }
                }}
              >
                {link.label}
              </Link>
            </div>
          ))}
      </div>
    </WFPFooter>
  );
};

export default Footer;
